import { Directive, Input, ElementRef, AfterViewInit, EventEmitter } from '@angular/core';

import Inputmask from 'inputmask';
import { Calendar } from 'primeng/calendar';

/**
 * Mask directive for calendar
 */
@Directive({
  selector: '[appCalendarMask]',
})
export class CalendarMaskDirective implements AfterViewInit {
  /**
   * input element
   */
  private input: HTMLInputElement;

  /**
   * place holder for the input
   */
  private slotChar = 'mm/dd/yyyy';

  /**
   * blur event
   */
  @Input() onInputBlur: Function = () => {};

  /**
   * value of the input field
   */
  private value = '';

  /**
   * constructor to inject dependency
   * @param host instance of elementRef
   */

  constructor(private host: ElementRef, private pCalendar: Calendar) {}

  /**
   * after view is initialized, initialize inputmask with date field
   */
  ngAfterViewInit(): void {
    new Inputmask('99/99/9999').mask(this.getHTMLInput());
  }

  /**
   * get the input element
   * @returns input element
   */
  getHTMLInput(): HTMLInputElement {
    console.log(this.pCalendar.el.nativeElement.querySelector('input'));
    return this.pCalendar.el.nativeElement.querySelector('input');
  }
}
